import styled from "styled-components"
import { COLORS } from "../constants"

const StyledInput = styled.input`
    height: 50px;
    background-color: ${COLORS.light_grey};
    border: solid 3px ${COLORS.light_grey_darker};
    border-radius: 10px;
    padding: 0 10px;
    -webkit-appearance: none;
    transition: border-color 0.2s;

    &:hover{
        border: solid 3px ${COLORS.light_grey_darker_hover};
    }
    &:focus{
        outline: none;
        border: solid 3px ${COLORS.light_grey_darker_hover};
    }
`;
export function CustomInput(props) {
    return (
        <StyledInput {...props} autoComplete="off" autoSave="off" autoCapitalize="none" />
    );
}
